module.exports = __webpack_public_path__ + "img/vmc_aniv14_24Aug2021.f1799234.jpg";